export default function UnauthorizedRedirect(personinfo, persontype, navigate) {
    const isPersonTypeArray = Array.isArray(persontype);
    if (isPersonTypeArray) {
        if (persontype.includes('All') || !persontype.includes(personinfo.personType)) {
            if (navigate) {
                navigate('/un-authorized', { replace: true });
            } else {
                window.location.replace('/un-authorized');
            }
            return;
        }
    } else {
        if (persontype !== 'All' && personinfo.personType !== persontype) {
            if (navigate) {
                navigate('/un-authorized', { replace: true });
            } else {
                window.location.replace('/un-authorized');
            }
            return;
        }
    }
}
